export enum OscPlatform {
  Desktop = 'desktop',
  IOs = 'ios',
  Android = 'android',
  Web = 'web',
  Window = 'window'
}
